var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('p',[_vm._v("読み込みに失敗しました"),_c('br'),(_vm.hrefDocument)?_c('span',[_vm._v("書籍閲覧画面にアクセスしてください")]):_vm._e()]),_vm._v(" "),(_vm.hrefDocument)?_c('viewer-link',{attrs:{"href-document":_vm.hrefDocument}},[_vm._v("進む")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }